module.exports = __webpack_public_path__ + "static/img/modal-bg.7b331a5e.png";